<template>
  <section class="app-main">
    <transition name="fade-transform" mode="in-out">
      <keep-alive>
        <router-view :key="Math.random()"/>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/components/appMain.vue